import { gql, useLazyQuery } from '@apollo/client';
import { Badge } from '@chakra-ui/react';
import useStore from '../../store';
import { useDebounceEffect } from '../form/useDebounceEffect';

const QUERY_COUNT = gql`
	query {
		countUnreadLeaveRequest
	}
`;

function LeaveRequestBadge() {
	const { countUnreadNotifications } = useStore((state) => state?.countUnreadNotifications);
	const [loadCount, { data: countData }] = useLazyQuery(QUERY_COUNT);

	useDebounceEffect(loadCount, 200, [countUnreadNotifications]);

	return (
		<>
			{parseInt(countData?.countUnreadLeaveRequest) > 0 && (
				<Badge fontSize="x-large" zIndex="99" top="2px" right="2px" position="absolute" colorScheme="red">
					{parseInt(countData?.countUnreadLeaveRequest)}
				</Badge>
			)}
		</>
	);
}

export default LeaveRequestBadge;
